import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.26562 4.76036L2.79007 6.92383C2.84789 7.0102 2.92551 7.08152 3.01646 7.13184C3.10741 7.18216 3.20907 7.21004 3.31297 7.21314C3.41686 7.21625 3.52 7.19449 3.61379 7.14969C3.70759 7.10489 3.78932 7.03833 3.8522 6.95556L8.73229 0.78125", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
